export default {
  'member.column.first_name': '名',
  'member.column.last_name': '姓',
  'member.column.role': '角色',
  'member.column.pin': '设备Pin码',
  'member.column.email': '邮箱',
  'member.column.phone_number': '手机号',
  'member.column.status': '状态',
  'member.column.created_at': '入职日期',
  'member.column.action': '操作',
  'member.column.password': '登录密码',
  'member.column.birthday': '生日(选填)',
  'member.column.role_id': '角色',
  'member.column.department_id': '部门',
  'member.column.hourly_rate': '时薪',
  'member.column.login_method': '登录方式',
  'member.column.driver': '司机',

  'member.add.title': '新建员工',
  'member.edit.title': '编辑员工',
  'member.section.basicInfo': '基本信息',
  'member.section.workInfo': '工作信息',
  'member.section.note': '备注',
  'member.note.empty': '什么都没有，写点啥吧',

  'member.created_at.desc': '入职日期 {created_at}',
  'member.hourly_rate.desc': '每小时 {hourly_rate}',

  'memberEdit.pin.error.lengthNotMatch': 'Pin码必须是4位数字',
  'memberEdit.email.error.invalid': '邮箱格式不正确',
  'memberEdit.password.error.empty': '密码不能为空',
  'memberEdit.password.error.notMatch': '密码至少8个字符(至少一个小写字母，至少一个大写字母，至少一个数字)',
  'memberEdit.detectingCamera': '正在检测摄像头',
  'memberEdit.noDetectCamera': '未检测到摄像头',
  'memberEdit.cameraPermissionDenied': '您未允许此网站使用您的摄像头。',
  'memberEdit.invalidQRCode': '无效QR码(限制: 纯数字字符，最多30位)',

  'member.loginMethod.device_pin': '设备pin码',
  'member.loginMethod.scan_pin': '扫码登录',
  'member.assignOwnerPrompt': '确认要将此员工的角色设置为“餐厅老板”吗？',
};
